<template>
  <div>
    <form @submit.prevent="submit()">
      <b-field label="公開終了日">
        <b-datepicker
          placeholder="選択してください"
          v-model="form.expires_at"
          :min-date="new Date()"
          :month-names="monthNames"
          :day-names="dayNames"
          :date-formatter="dateFormatter"
        />
      </b-field>

      <button class="button is-primary" type="submit">更新する</button>
    </form>
  </div>
</template>

<script>
import axios from '@/axios'
import moment from 'moment'

export default {
  props: ['survey'],

  data() {
    return {
      monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
      dayNames: ["日", "月", "火", "水", "木", "金", "土"],
      dateFormatter: (date) => moment(date).format('YYYY年MM月DD日'),
      form: {
        expires_at: new Date(this.survey.expires_at),
      },
    }
  },

  methods: {
    submit() {
      axios.patch('/api/app/surveys/' + this.survey.id, this.form).then(() => {
        this.$parent.close()
      })
    },
  }
}
</script>

<style scoped>
</style>
